export const filterExternalLinks = (links) =>
  links.filter((link) => {
    return !link.NavigateURL.includes('.aspx');
  });

export const getFilteredAdminNavigationLinkForMobile = (contentData) => {
  const templateData = contentData?.templateData ?? [];

  const filteredItems = templateData
    .map((templateDataItem) => ({
      ...templateDataItem,
      Links: filterExternalLinks(templateDataItem.Links),
    }))
    .filter((item) => item.Links.length !== 0);

  return { ...contentData, templateData: filteredItems };
};
